export default __webpack_public_path__ + "5e216d7d1d1b18146dc63431e6cf66e7.svg";